import { ANALYTIC_BASE_URL, BACKEND_BASE_URL, REVIEW_BASE_URL } from "../config";
import { ConditionFact, PageType } from '@reconvert/reconvert-utils';

export const API_BASE_URL = BACKEND_BASE_URL;
export const API_ANALYTIC_URL = ANALYTIC_BASE_URL;
export const API_REVIEW_URL = REVIEW_BASE_URL;

//API variables
export const AUTH_LOGIN = "/auth/login";
export const AUTH_TOKEN = "/auth/token";
export const GET_CONDITION = "/conditions";
export const GET_CONDITION_BY_ID = (id: string) => `/conditions/${id}`;
export const UPDATE_SLOT = (slotId: string) => `/slots/${slotId}`;
export const UPDATE_SLOT_STATUS = () => `/slots/updateSlotStatus`;
export const UPDATE_SLOT_CONFIGURATION = (slotConfigId: string) => `/slots/configuration/${slotConfigId}`;
export const SLOT = `/slots`;
export const SLOT_LOGIN = `/slots/login`;
export const CREATE_VARIANTS = "/variants";
export const UPDATE_VARIANT = "/variants";
export const UPDATE_VARIANT_BY_ID = (id: string) => `/variants/${id}`;
export const GET_VARIANT_BY_ID = (id: string, sendSlotName = true) =>
  `/variants/${id}?sendSlotName=${sendSlotName}`;
export const UPDATE_CONDITION = (id: string) => `/conditions/${id}`;
export const UPDATE_CONDITIONS = `/conditions`;
export const DELETE_VARIANTS_BY_ID = (variantId: string) => `/variants/${variantId}`;
export const DELETE_CONDITIONS_BY_ID = (variantId: string) => `/conditions/${variantId}`;
export const DELETE_SLOT = (slotNumber: number, location: string) => `/slots/${slotNumber}?location=${location}`;
export const GET_SLOT_STATUS = (slotNumber: number, location: string) =>
  `/slots/${slotNumber}/status?location=${location}`;
export const GET_PRODUCT = `/store/products-search`;
export const GET_TAGS = `/store/tags`;
export const GET_PRODUCT_SALES_CHANNEL = `/store/sales-channels`;
export const GET_PRODUCT_VENDORS = `/store/product-vendors`;
export const GET_LANGUAGE = `/store/languages`;
export const GET_COUNTRIES = `/store/countries`;
export const GET_CUSTOMER_SEGEMENTS = `/store/segments`;
export const GET_SHIPPING_METHODS = `/store/shipping-methods`;
export const GET_PRODUCT_COLLECTION = `/store/collections/search`;
export const GET_PRODUCT_TYPE = `/store/product-types`;
export const GET_FLOW_BUILDER_BANNERS = `/editor/banners?status=ACTIVE&position=FLOW_BUILDER`;
export const ADMIN_BANNER_CLICK = `/reconvert/add-admin-banner-click`;
export const ADMIN_BANNER_IMP = `/reconvert/add-admin-banner-imp`;
export const GET_SUBSCRIBER = `/editor/subscribers`;
export const GET_SUPPORT_CHAT_JWT = `/editor/mantle-jwt`;
export const SEND_MESSAGE = `/editor/mantle-help-desk-ticket`;
export const GET_BANNER_ANALYTICS = (store: string) => `/analytics?store=${store}`;
export const GET_VARIANT = (productIds: string) => `/store/variants/?productIds=${productIds}&limit=250`;
export const GET_ALL_VARIANT_ANALYTICS = (fromDate: string, toDate: string, conditionId: string, location: string) =>
  `/analytics/getAggregatedData?base=SLOT_VARIANT&location=${location}&conditionIds=${conditionId}&fromDate=${fromDate}&toDate=${toDate}&groupBy=SLOT`;
export const GET_VARIANTS_ANALYTICS = (fromDate: string, toDate: string, variantId: string, location: string) =>
  `/analytics/getAggregatedData?base=SLOT_VARIANT&location=${location}&variantIds=${variantId}&fromDate=${fromDate}&toDate=${toDate}&baseId=${variantId}`;
export const GET_WIDGET_ANALYTICS = (fromDate: string, toDate: string, variantId: string, location: string) =>
  `/analytics/getAggregatedData?base=WIDGET&location=${location}&variantIds=${variantId}&fromDate=${fromDate}&toDate=${toDate}`;
export const CHECKOUT_PROFILE = "/editor/checkout_profile";
export const GET_VARIANTS_LIST = `/variants`;
export const GET_ALL_VARIANTS = (conditionId: string, slotNo: number, excludeWidgets: boolean) =>
  `/variants/?conditionId=${conditionId}&slotNo=${slotNo}&excludeWidget=${excludeWidgets}`;
export const GET_SHOP_INFO = `/store/info`;
export const UPDATE_SHOP_INFO = `/store/info`;
export const GET_WIX_SITE_TYPE = `/store/editor-urls`;
export const SYNC_SLOT_STATUS = `/editor/sync-slot-status`;
export const GET_ORDER_TAGS = `/store/order-tags?limit=250`;

export const GET_CUSTOMER_TAGS = `/store/customer-tags`;
export const SEGMENT_TRACK = `/segments/track`;
export type ApiError = { path?: string; message: string };
export type ErrorResponseBody = { success: false; errors: ApiError[] };
export type CreateOrReadResponseBody<T = any> = { success: true; data: T } | ErrorResponseBody;
export type UpdateOrDeleteResponseBody = { success: true; errors?: ApiError[] } | ErrorResponseBody;  
export type updateSubscriptionResponseBody = { success: true; errors?: ApiError[]; data: any } | ErrorResponseBody;
export type getSubscriptionDetailsResponseBody = { success: true; errors?: ApiError[]; data: any } | ErrorResponseBody;
export type getSupportChatJwtResponseBody = { success: true; errors?: ApiError[]; data: any } | ErrorResponseBody;
export type syncSlotStatusResponseBody = { success: true; errors?: ApiError[]; data: any } | ErrorResponseBody;
export type sendMessageResponseBody = { success: true; errors?: ApiError[]; data: any } | ErrorResponseBody;

//REVIEW COLLECTOR APIS
export const GET_USER_REVIEW_ELIGBLITY = (storeId: string) => `/store/${storeId}/review-eligibility`;

//UNLEASH KEYS
export const UNLEASH_SHOW_CART_DRAWER = "show-cart-drawer";
export const UNLEASH_ENABLE_ANNOUNCEMENT_BAR = "enable-announcement-bar";
export const UNLEASH_ENABLE_WIX_PRODUCT_PAGE = "enable_wix_product_page";
export const UNLEASH_MARKETING_CONSENT_CONDITION = "marketing-consent-condition";
export const UNLEASH_PRODUCT_PRICE_CONDITION = "product-price-condition";
export const UNLEASH_PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING = "physical-product-or-require-shipping";
export const UNLEASH_TOTAL_ITEM_COUNT_CONDITION = "total-item-count-condition";
export const UNLEASH_SHIPPING_VALUE_CONDITION = "shipping-value-condition";
export const UNLEASH_ORDER_NOTE_CONDITION = "order-note-condition";
export const UNLEASH_ENABLE_PRODUCT_TYPE = "product-type-condition";
export const UNLEASH_ENABLE_FULLFILLMENT_STATUS_CONDITION = "fullfillment-status-condition";
export const UNLEASH_ENABLE_PAYMENT_STATUS_CONDITION = "payment-status-condition";
export const UNLEASH_ENABLE_PRODUCT_VENDOR_CONDITION = "product-vendor-condition";
export const UNLEASH_ENABLE_SHIPPING_METHOD_CONDITION = "shipping-method-condition";
export const UNLEASH_ENABLE_ORDER_TAGS_CONDITION = "order-tags-condition";
export const UNLEASH_PRODUCT_ITEM_COST_CONDITION = "item-cost-condition";
export const UNLEASH_PRODUCT_AVAILABLE_AT_SALES_CHANNEL_CONDITION = "product-available-at-sales-channel-condition";
export const UNLEASH_ENABLE_PAYMENT_METHODS = "payment-method";
export const UNLEASH_ENABLE_NUMBER_OF_ORDERS = "number-of-orders-condition";
export const UNLEASH_ENABLE_CUSTOMER_EMAIL = "customer-email-conditions";
export const UNLEASH_ENABLE_TIME_SINCE_LAST_ORDER = "time-since-last-order-condition";
export const UNLEASH_ENABLE_CUSTOMER_TAG = "customer-tag-condition";
export const UNLEASH_ENABLE_CUSTOMER_BIRTHDAY = "customer-birthday-condition";
export const UNLEASH_SUPPORT_CHAT_PROVIDER = 'support-chat-provider';

export const WIX_SITE_TYPE = {
    WIX_STUDIO: "WIX_STUDIO",
    WIX_EDITOR: "WIX_EDITOR",
  };
  
export type UnleashFlag = typeof UNLEASH_SHOW_CART_DRAWER | typeof UNLEASH_ENABLE_WIX_PRODUCT_PAGE;

export const FULFILLMENT_STATUS = [
  { name: "Fulfilled", id: "FULFILLED" },
  { name: "In progress", id: "IN_PROGRESS" },
  { name: "On hold", id: "ON_HOLD" },
  { name: "Open", id: "OPEN" },
  { name: "Partially fulfilled", id: "PARTIALLY_FULFILLED" },
  { name: "Pending fulfillment", id: "PENDING_FULFILLMENT" },
  { name: "Request declined", id: "REQUEST_DECLINED" },
  { name: "Restocked", id: "RESTOCKED" },
  { name: "Scheduled", id: "SCHEDULED" },
  { name: "Unfulfilled", id: "UNFULFILLED" },
];
export const PAYMENT_STATUS_OPTIONS = [
  {label: "Authorized", value: "AUTHORIZED"},
  {label: "Expired", value: "EXPIRED"},
  {label: "Paid", value: "PAID"},
  {label: "Partially paid", value: "PARTIALLY_PAID"},
  {label: "Partially refunded", value: "PARTIALLY_REFUNDED"},
  {label: "Panding", value: "PENDING"},
  {label: "Refunded", value: "REFUNDED"},
  {label: "Voided", value: "VOIDED"}
];

export const PAYMENT_METHODS_OPTIONS: { displayName: string; value: string }[] = [
  {
    "displayName": "PayPal Express Checkout",
    "value": "paypal"
  },
  {
    "displayName": "Cash on Delivery (COD)",
    "value": "cash_on_delivery_(cod)"
  },
  {
    "displayName": "Shopify Payments",
    "value": "shopify_payments"
  },
  {
    "displayName": "Bank Deposit",
    "value": "bank_deposit"
  },
  {
    "displayName": "Cartão de Crédito e Boleto via EBANX",
    "value": "cartão_de_crédito_e_boleto_via_ebanx"
  },
  {
    "displayName": "Cash",
    "value": "cash"
  },
  {
    "displayName": "Amazon Pay",
    "value": "amazon_payments"
  },
  {
    "displayName": "Pago con tarjeta de crédito y débito",
    "value": "pago_con_tarjeta_de_crédito_y_débito_by_paypal"
  },
  {
    "displayName": "Stripe",
    "value": "stripe"
  },
  {
    "displayName": "Stripe Connect",
    "value": "stripe_connect"
  },
  {
    "displayName": "Rechnung mit Klarna",
    "value": "rechnung_mit_klarna"
  },
  {
    "displayName": "Amazon",
    "value": "amazon"
  },
  {
    "displayName": "Cash on Delivery",
    "value": "cash_on_delivery"
  },
  {
    "displayName": "Cashfree",
    "value": "cashfree"
  },
  {
    "displayName": "Amazon Marketplace",
    "value": "amazon_marketplace"
  },
  {
    "displayName": "Wanelo",
    "value": "wanelo"
  },
  {
    "displayName": "ViaBill North America",
    "value": "viabill_north_america"
  },
  {
    "displayName": "Other",
    "value": "other"
  }
]

export const SegmentEventPageNames = {
  [PageType.PRE_PURCHASE_CART_DRAWER_PAGE]: 'cart drawer',
  [PageType.PRE_PURCHASE_CART_PAGE]: 'cart page',
  [PageType.PRE_PURCHASE_PRODUCT_PAGE]: 'product page',
  [PageType.CHECKOUT]: 'checkout',
  [PageType.POST_PURCHASE_PAGE1]: 'post purchase 1',
  [PageType.POST_PURCHASE_PAGE2]: 'post purchase 2',
  [PageType.THANK_YOU_PAGE]: 'thank you page',
  [PageType.ORDER_STATUS_PAGE]: 'order status page',
  [PageType.FORM_EDITOR]: null,
};

export const CONDITION_OPTIONS_GROUPED = [
  {
    groupLabel: "Product Details",
    facts: [
      ConditionFact.SPECIFIC_PRODUCT,
      ConditionFact.PRODUCT_COLLECTION,
      ConditionFact.PRODUCT_TAGS,
      ConditionFact.PRODUCT_SKU,
      ConditionFact.PRODUCT_TYPE,
      ConditionFact.PRODUCT_VENDOR,
      ConditionFact.PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL,
      ConditionFact.PRODUCT_TITLE,
      ConditionFact.PRODUCT_VARIANT_NAME,
      ConditionFact.PRODUCT_PRICE,
      ConditionFact.PRODUCT_ITEM_COST,
      ConditionFact.PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING,
    ],
  },
  {
    groupLabel: "Cart & Order Information",
    facts: [
      ConditionFact.PREV_PAGE_OFFER,
      ConditionFact.CART_OR_ORDER_VALUE,
      ConditionFact.TOTAL_ITEM_COUNT,
      ConditionFact.DISCOUNT_CODE,
      ConditionFact.SHIPPING_VALUE,
      ConditionFact.SHIPPING_METHOD,
      ConditionFact.PAYMENT_METHOD,
      ConditionFact.ORDER_NOTE,
      ConditionFact.ORDER_TAGS,
      ConditionFact.PAYMENT_STATUS,
      ConditionFact.FULFILLMENT_STATUS,
    ],
  },
  {
    groupLabel: "Customer information",
    facts: [
      ConditionFact.CUSTOMER_SEGMENTS,
      ConditionFact.CUSTOMER_LANGUAGE,
      ConditionFact.CUSTOMER_COUNTRY,
      ConditionFact.MARKETING_CONSENT,
      ConditionFact.CUSTOMER_NUMBER_OF_ORDERS,
      ConditionFact.CUSTOMER_TIME_SINCE_LAST_ORDER,
      ConditionFact.CUSTOMER_EMAIL,
      ConditionFact.CUSTOMER_BIRTHDAY,
      ConditionFact.CUSTOMER_TAGS,
    ],
  },
];
